if (window.top !== window.self) {
  window.top.location = window.self.location;
}
